export const ATLAS_V1_SOFTWARE_INFO_LOAD = 'ATLAS_V1_SOFTWARE_INFO_LOAD';
export const ATLAS_V1_SOFTWARE_NOT_AUTHORIZED =
  'ATLAS_V1_SOFTWARE_NOT_AUTHORIZED';
export const ATLAS_V1_DATA_LOAD = 'ATLAS_V1_DATA_LOAD';
export const SET_IS_DONE_LOADING_INSTALLER = 'SET_IS_DONE_LOADING_INSTALLER';
